// extracted by mini-css-extract-plugin
export default {"tabs":"ClientBarcodeForm_tabs__dcAQw","tabsItem":"ClientBarcodeForm_tabsItem__8ji2A","tabsItem__active":"ClientBarcodeForm_tabsItem__active__JARAq"};